module.exports = __webpack_public_path__ + "static/media/PacketsNew.428b627d.logo";